import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewBillingConfigurationsWrapper = styled.div`
  margin: 0 16px;
  .billing-configurations-container {
    margin: 16px 0;
  }

  .MuiCollapse-wrapper {
    background-color: #f5f5f5;
  }

  .separator-space {
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }

  .program-template-heading {
    margin: 24px 0;
    ${responsive.MOBILE`
      margin: 16px 0;
    `}
  }
  .billing-configurations,
  .program-template-container {
    margin: 24px 16px;
    ${responsive.MOBILE`
      margin: 16px 8px;
    `}
  }
  .special-billing-instructions {
    padding-top: 24px;
  }
`;
